import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {RequestService} from "../../services/request";
import {Request} from "../../classes/request";
import {CustomerService} from "../../services/customer";
import {Customer} from "../../classes/customer";
import {FileService} from "../../services/file";
import {DocumentService} from "../../services/document";
import {Document} from "../../classes/document";
import {saveAs} from "file-saver";
import {GoogleDriveService} from "../../services/googleDrive";
import {EmailService} from "../../services/email";
import {RequestAccessService} from "../../services/requestAccess";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
    RequestInfoPaymentModalComponent
} from "../../modals/request/request-info-payment-modal/request-info-payment-modal.component";
import {
    VideoModalComponent
} from "../../modals/video/video-modal/video-modal.component";
import * as pdfjsLib from 'pdfjs-dist';


import config from "../../config.json";
import { NgForm } from '@angular/forms';
import {
    createDefaultDepreciationAssets,
    createEmptyDepreciationAsset,
    initializeDepreciationAssetsState,
    isDepreciationDataInvalid,
    syncDepreciationFieldsForSave
} from "../../utils/depreciationAssets";
import {
    isCustomerDocumentType
} from "../../utils/customerDocuments";
import {
    computeFormattedCaretPosition,
    finalizeItalianAmountOnBlur,
    formatItalianAmountWhileTyping,
    formatNumberToItalianAmount,
    parseItalianAmountToNumber
} from "../../utils/italianAmountInput";

@Component({
    selector: 'app-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {
    serverAddress: string = '';
    startingVideoShow: boolean = true;
    request: Request = new Request();
    /** Customer di lavoro: esistente (da P.IVA) oppure locale da creare al termine dello step Dati. */
    customer: Customer = new Customer();
    loadingCondition: boolean = false;
    /** Messaggio di errore mostrato quando il salvataggio asincrono dello step 0 fallisce. */
    stepAdvanceError: string | null = null;
    simplifiedRequestSteps: {
        step1: boolean,
        step2: number,
        step3: boolean,
        customerFound: Customer | null,
        lastBalance: boolean
    } = {
        step1: false,
        step2: 0,
        step3: false,
        customerFound: null,
        lastBalance: false
    };
    hyperDepreciationStep = false;
    hyperDepreciationContractStep = false;
    multipleDepreciationRates = false;
    visuraParsingResult: { success: any[], errors: string[] } | null = null;
    checkboxVisuraData: boolean = false;
    editingVisuraField: string | null = null;
    editingVisuraValue: string = '';
    radioBasicOptions: any = [{ value: true, label: 'Sì' }, { value: false, label: 'No' }];
    radioInvestmentModeOptions: string[] = [ 'Leasing', 'Finanziamento' ];
    radioTaxCredit5BusinessExpansionOptions: string[] = [ 'Ampliamento Aziendale', 'Sostituzione' ];
    radioInvestmentDurationOptions: string[] = [ '2', '3', '4', '5' ];
    checkboxInvestmentTypeOptions: any = [ 'Ordinario', 'Green', '4.0' ];
    radioStructureOwnerOptions: string[] = [ 'Affittuaria', 'Proprietaria' ];
    checkboxInvestmentTypeValues: any = [ false, false, false ];
    checkboxRelease: boolean[] = [ false, false, false ];
    /** Valore visualizzato per l'importo investimento (formato italiano). */
    investmentAmountDisplay = '';
    private previousInvestmentAmountDisplay = '';
    fileVisuraStep1: File | null = null;
    fileLastBalanceStep1: File | null = null;
    fileName: any = {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        7: '',
        8: '',
        9: '',
        10: '',
        11: '',
        12: '',
        13: '',
        14: '',
        15: '',
        16: '',
        17: '',
        29: ''
    };
    fileData: any = {
        1: new FormData(),
        2: new FormData(),
        3: new FormData(),
        4: new FormData(),
        5: new FormData(),
        6: new FormData(),
        7: new FormData(),
        8: new FormData(),
        9: new FormData(),
        10: new FormData(),
        11: new FormData(),
        12: new FormData(),
        13: new FormData(),
        14: new FormData(),
        15: new FormData(),
        16: new FormData(),
        17: new FormData(),
        29: new FormData()
    };
    documentList: any = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
        8: [],
        9: [],
        10: [],
        11: [],
        12: [],
        13: [],
        14: [],
        15: [],
        16: [],
        17: [],
        29: []
    };
    documentTypeName: any = {
        1: 'VISURA',
        2: 'BILANCIO',
        3: 'MARCA_BOLLO',
        4: 'CARTA_IDENTITA',
        5: 'OFFERTA',
        6: 'CONTRATTO_LIBERATORIA_PROCURA_PRIVACY',
        7: 'PAGAMENTO',
        8: 'DURC',
        9: 'REGISTRI_IVA',
        10: 'FATTURE',
        11: 'PERIZIA_4',
        12: 'CARTA_IDENTITA_PERITO_4',
        13: 'CERTIFICAZIONE_EX_ANTE_5',
        14: 'CARTA_IDENTITA_ING_ENERGETICO',
        15: 'LIBRO_CESPITI',
        16: 'VISURA_STRUTTURA',
        17: 'CONTRATTO_AFFITTO_STRUTTURA',
        29: 'DVR'
    };

    constructor(private route: ActivatedRoute,
                private modalService: NgbModal,
                private requestService: RequestService,
                private customerService: CustomerService,
                private fileService: FileService,
                private documentService: DocumentService,
                private googleDriveService: GoogleDriveService,
                private emailService: EmailService,
                private requestAccessService: RequestAccessService) { pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/support/pdf.worker.min.js'; }

    private isRequestType7(): boolean {
        return this.request.FKIDRequestType === 7;
    }

    private normalizeProgressStatusForRequestType7(): boolean {
        if (this.isRequestType7() && (this.request.ProgressStatus === 6 || this.request.ProgressStatus === 7)) {
            this.request.ProgressStatus = 8;
            return true;
        }
        return false;
    }

    private getDocumentsToSignFileName(): string {
        return this.request.FKIDRequestType === 5
            ? 'Contratto di Consulenza.pdf'
            : 'Contratto Liberatoria Procura Privacy.pdf';
    }

    /**
     * La lista mostra i documenti della pratica: solo-richiesta e satelliti dei master
     * cliente. I master non compaiono, così il cestino agisce sempre sulla copia della pratica.
     */
    private refreshDocumentList(): void {
        if (!this.request.IDRequest) {
            return;
        }
        this.documentService.getAllByIDRequest(this.request.IDRequest.toString())
            .subscribe({
                next: (documentList: any) => {
                    this.documentList = documentList;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    private triggerDocumentsToSignDownload(autoDownload = true): void {
        this.documentService.downloadDocumentsToSign(this.request.IDRequest!.toString())
            .subscribe({
                next: (blobFile) => {
                    if (autoDownload) {
                        saveAs(blobFile, this.getDocumentsToSignFileName());
                    }
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
        this.refreshDocumentList();
    }

    private generateRecapDocument(autoDownload = true): void {
        this.documentService.downloadRecapDocument(this.request.IDRequest!.toString())
            .subscribe({
                next: (blobFile) => {
                    if (autoDownload) {
                        saveAs(blobFile, 'Riepilogo Pratica - Tevanpal.pdf');
                    }
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    /**
     * Assicura che i master del customer abbiano un satellite Drive su questa pratica.
     * Poi ricarica la lista documenti (UI = satellite) e opzionalmente scarica i documenti da firmare.
     */
    private syncCustomerDocumentsThenRefresh(autoDownloadDocumentsToSign = true): void {
        const runAfterSync = () => {
            this.triggerDocumentsToSignDownload(autoDownloadDocumentsToSign);
        };

        if (!this.request.IDRequest || !this.request.FKIDCustomer || !this.request.IDFolderGoogleDrive) {
            runAfterSync();
            return;
        }

        this.documentService.syncCustomerDocumentsToRequest({
            IDRequest: this.request.IDRequest,
            IDCustomer: this.request.FKIDCustomer,
            IDFolderGoogleDrive: this.request.IDFolderGoogleDrive,
            IDFolderGoogleDriveSecondary: this.request.IDFolderGoogleDriveSecondary || null
        }).subscribe({
            next: () => runAfterSync(),
            error: (err: HttpErrorResponse) => {
                console.log(err);
                // Anche se lo sync fallisce, non bloccare lo step documenti
                runAfterSync();
            }
        });
    }

    private onEnterStep8(autoDownload = true): void {
        this.syncCustomerDocumentsThenRefresh(autoDownload);
    }

    private initializeStep8Documents(): void {
        this.syncCustomerDocumentsThenRefresh(false);
    }

    /**
     * Registra l'accesso alla pratica. Se l'utente è loggato l'interceptor aggiunge il JWT e il backend
     * lo attribuisce all'utente, altrimenti all'(unico) cliente collegato alla pratica.
     * Un errore di tracciamento non deve mai bloccare la compilazione.
     */
    private trackAccess(sessionToken: string): void {
        if (!sessionToken) {
            return;
        }
        this.requestAccessService.create(sessionToken)
            .subscribe({
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    ngOnInit(): void {
        this.serverAddress = config.serverAddress + ':' + config.serverPort + '/';
        this.route.queryParams.subscribe(params => {
            this.requestService.getByToken(params['session'])
                .subscribe({
                    next: (request: Request) => {
                        this.request = request;
                        this.trackAccess(params['session']);
                        const statusNormalizedForRequestType7 = this.normalizeProgressStatusForRequestType7();
                        this.startingVideoShow = this.request.FKIDRequestType === 5;

                        if (this.request.ProgressStatus < 3) {
                            this.request.BusinessExpansion = true;
                        }
                        if (this.request.ReleaseAcceptance) {
                            this.checkboxRelease[0] = true;
                            this.checkboxRelease[1] = true;
                            this.checkboxRelease[2] = true;
                        }
                        if (this.request.FKIDRequestType === 5 || this.request.FKIDRequestType === 7) {
                            this.radioInvestmentModeOptions.push('Fondi Propri');
                        }
                        if (this.request.FKIDRequestType === 7) {
                            this.radioInvestmentDurationOptions.push('6');
                            this.radioInvestmentDurationOptions.push('7');
                            this.radioInvestmentDurationOptions.push('8');
                        }
                        let requestInvestmentTypes = this.request.InvestmentType?.split(',');
                        if (requestInvestmentTypes !== undefined && requestInvestmentTypes !== null) {
                            requestInvestmentTypes.forEach((requestInvestmentType: string) => {
                                const indexFound = this.checkboxInvestmentTypeOptions.findIndex((checkboxInvestmentTypeOption: string) => {
                                    return checkboxInvestmentTypeOption === requestInvestmentType;
                                });
                                if (indexFound > -1) {
                                    this.checkboxInvestmentTypeValues[indexFound] = true;
                                }
                            });
                        }
                        if (this.request.FKIDRequestType === 2 || this.request.FKIDRequestType === 4) {
                            this.checkboxInvestmentTypeValues[1] = true;
                        } else if (this.request.FKIDRequestType === 3 || this.request.FKIDRequestType === 5
                            || this.request.FKIDRequestType === 6 || this.request.FKIDRequestType === 7) {
                            this.checkboxInvestmentTypeValues[2] = true;
                        }
                        this.multipleDepreciationRates = initializeDepreciationAssetsState(this.request);
                        this.investmentAmountDisplay = formatNumberToItalianAmount(this.request.InvestmentAmount);
                        this.previousInvestmentAmountDisplay = this.investmentAmountDisplay;
                        this.refreshDocumentList();
                        this.loadCustomerForRequest();

                        if (statusNormalizedForRequestType7) {
                            this.requestService.update(this.request)
                                .subscribe({
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                    }
                                });
                        }

                        if (this.request.ProgressStatus === 8) {
                            this.initializeStep8Documents();
                        }
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    get birthDateString(): string {
        if (!this.customer.BirthDate) {
            return '';
        }
        const date = new Date(this.customer.BirthDate);
        // Uso metodi UTC per evitare che il fuso orario sposti la data di un giorno (es. UTC-5)
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
      
    set birthDateString(value: string) {
        if (!value) {
            this.customer.BirthDate = null;
            return;
        }
        // Parsing esplicito YYYY-MM-DD come data di calendario (mezzanotte UTC) per evitare sfasamenti
        const [y, m, d] = value.split('-').map(Number);
        this.customer.BirthDate = new Date(Date.UTC(y, m - 1, d));
    }

    private normalizeBirthDateToUtcMidnight(date: Date | string | null): Date | null {
        if (date == null) {
            return null;
        }
        const d = new Date(date);
        if (isNaN(d.getTime())) {
            return null;
        }
        return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    }

    /** Tra le pratiche del customer, prende l'ultima di tipo 6 o 7 (per sede operativa / catastale). */
    private getLatestType67Request(requests: Request[]): Request | null {
        const type67Requests = (requests || [])
            .filter(request => request.FKIDRequestType === 6 || request.FKIDRequestType === 7);
        if (type67Requests.length === 0) {
            return null;
        }
        return type67Requests.reduce((latest, current) =>
            (current.IDRequest ?? 0) > (latest.IDRequest ?? 0) ? current : latest
        );
    }

    private copySimplifiedType67FieldsFrom(source: Request): void {
        this.request.OperationalHeadquarters = source.OperationalHeadquarters;
        this.request.OperationalHeadquartersProvince = source.OperationalHeadquartersProvince;
        this.request.OperationalHeadquartersAddress = source.OperationalHeadquartersAddress;
        this.request.OperationalHeadquartersHouseNumber = source.OperationalHeadquartersHouseNumber;
        this.request.TaxCredit5CadastralCode = source.TaxCredit5CadastralCode;
        this.request.TaxCredit5CadastralSection = source.TaxCredit5CadastralSection;
        this.request.TaxCredit5CadastralSheet = source.TaxCredit5CadastralSheet;
        this.request.TaxCredit5CadastralParticle = source.TaxCredit5CadastralParticle;
        this.request.TaxCredit5CadastralSub = source.TaxCredit5CadastralSub;
    }

    private proceedSimplifiedStep0(driveFolderName: string, onDone: (success: boolean) => void): void {
        this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
            .subscribe({
                next: (folderCreated: any) => {
                    if (this.request.FKIDRequestType !== 6) {
                        this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                    } else {
                        this.request.IDFolderGoogleDrive = folderCreated.IDFolderDNS;
                        this.request.IDFolderGoogleDriveSecondary = folderCreated.IDFolderIP4;
                    }
                    this.requestService.update(this.request)
                        .subscribe({
                            next: () => {
                                if (this.simplifiedRequestSteps.lastBalance && this.fileData[2]?.has('uploadFile')) {
                                    this.createDocument(2);
                                }
                                this.refreshDocumentList();
                                onDone(true);
                            },
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                                onDone(false);
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    onDone(false);
                }
            });
    }

    /**
     * Aggiorna il customer trovato con i dati letti dalla visura.
     * `onDone(success)` NON deve mai proseguire il flusso pratica se success è false:
     * i dati della visura andrebbero persi silenziosamente.
     */
    private updateFoundCustomerFromVisura(onDone: (success: boolean) => void): void {
        if (!this.customer?.IDCustomer) {
            onDone(true);
            return;
        }

        this.request.FKIDCustomer = this.customer.IDCustomer;
        this.simplifiedRequestSteps.customerFound = this.customer;

        console.log('[DEBUG][updateFoundCustomerFromVisura] payload inviato a /customer/update:', JSON.parse(JSON.stringify(this.customer)));
        this.customerService.update(this.customer)
            .subscribe({
                next: () => {
                    console.log('[DEBUG][updateFoundCustomerFromVisura] update completato con successo');
                    onDone(true);
                },
                error: (err: HttpErrorResponse) => {
                    console.log('[DEBUG][updateFoundCustomerFromVisura] ERRORE /customer/update:', err);
                    onDone(false);
                }
            });
    }

    /**
     * Cliente nuovo: persiste subito il customer (dati visura) e collega FKIDCustomer alla pratica,
     * così i dati non restano solo in memoria e sopravvivono al refresh.
     * `onDone(success)` NON deve mai proseguire il flusso pratica se success è false.
     */
    private ensureCustomerPersistedFromStep0(onDone: (success: boolean) => void): void {
        if (this.request.FKIDCustomer && !this.customer.IDCustomer) {
            this.customer.IDCustomer = this.request.FKIDCustomer;
        }

        if (this.customer.IDCustomer) {
            // Il customer era già collegato (es. tentativo precedente): i dati appena riletti
            // dalla visura vanno comunque salvati con un update esplicito, altrimenti restano
            // solo in memoria e vengono persi al refresh.
            this.request.FKIDCustomer = this.customer.IDCustomer;
            console.log('[DEBUG][ensureCustomerPersistedFromStep0] customer già collegato, invio update con i dati correnti:', JSON.parse(JSON.stringify(this.customer)));
            this.customerService.update(this.customer)
                .subscribe({
                    next: () => {
                        console.log('[DEBUG][ensureCustomerPersistedFromStep0] update customer già esistente completato con successo');
                        onDone(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log('[DEBUG][ensureCustomerPersistedFromStep0] ERRORE update customer già esistente:', err);
                        onDone(false);
                    }
                });
            return;
        }

        console.log('[DEBUG][ensureCustomerPersistedFromStep0] payload inviato a /customer/create:', JSON.parse(JSON.stringify(this.customer)));
        this.customerService.create(this.customer)
            .subscribe({
                next: (createdCustomer: Customer) => {
                    console.log('[DEBUG][ensureCustomerPersistedFromStep0] risposta da /customer/create:', JSON.parse(JSON.stringify(createdCustomer)));
                    this.customer = createdCustomer;
                    this.request.FKIDCustomer = createdCustomer.IDCustomer;
                    this.requestService.update(this.request)
                        .subscribe({
                            next: () => {
                                console.log('[DEBUG][ensureCustomerPersistedFromStep0] FKIDCustomer collegato con successo:', this.request.FKIDCustomer);
                                onDone(true);
                            },
                            error: (err: HttpErrorResponse) => {
                                console.log('[DEBUG][ensureCustomerPersistedFromStep0] ERRORE collegamento FKIDCustomer alla request:', err);
                                onDone(false);
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    console.log('[DEBUG][ensureCustomerPersistedFromStep0] ERRORE /customer/create:', err);
                    onDone(false);
                }
            });
    }

    private getCustomerDriveFolderName(): string {
        const companyName = this.customer.CompanyName || 'Cliente';
        const vatNumber = this.customer.VATNumber || '';
        return companyName + '---' + vatNumber + '_' + this.request.IDRequest!.toString();
    }

    /** Carica il customer collegato alla pratica (reload / ripresa sessione). */
    private loadCustomerForRequest(): void {
        if (!this.request.FKIDCustomer) {
            return;
        }
        this.customerService.getByID(this.request.FKIDCustomer.toString())
            .subscribe({
                next: (customer: Customer) => {
                    this.customer = customer;
                    this.simplifiedRequestSteps.customerFound = customer;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    /** Persistenza customer dallo step Dati: update se esiste, create altrimenti. */
    private saveCustomerFromStep2(onDone: () => void): void {
        if (this.request.FKIDCustomer && !this.customer.IDCustomer) {
            this.customer.IDCustomer = this.request.FKIDCustomer;
        }

        if (this.customer.IDCustomer) {
            this.customerService.update(this.customer)
                .subscribe({
                    next: () => {
                        this.request.FKIDCustomer = this.customer.IDCustomer;
                        onDone();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                        onDone();
                    }
                });
            return;
        }

        this.customerService.create(this.customer)
            .subscribe({
                next: (createdCustomer: Customer) => {
                    this.customer = createdCustomer;
                    this.request.FKIDCustomer = createdCustomer.IDCustomer;
                    this.requestService.update(this.request)
                        .subscribe({
                            next: () => onDone(),
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                                onDone();
                            }
                        });
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    onDone();
                }
            });
    }

    goStepForward(form?: NgForm) {
        // Evita doppi invii concorrenti (es. doppio click) mentre un avanzamento è già in corso.
        if (this.loadingCondition) {
            return;
        }

        if (!this.canAdvanceFromCurrentStep(form)) {
            if (form) {
                Object.keys(form.controls).forEach(field => {
                    const control = form.controls[field];
                    control.markAsDirty({ onlySelf: true });
                });
            }
            return;
        }

        this.syncDepreciationBeforeSave();

        switch (this.request.ProgressStatus) {
            case 0:
                this.loadingCondition = true;
                this.stepAdvanceError = null;

                if (this.simplifiedRequestSteps.step1 && this.simplifiedRequestSteps.step2 === 1 && !this.simplifiedRequestSteps.step3) {
                    this.request.Simplified = true;
                    this.request.DataVariation = this.simplifiedRequestSteps.step3;
                    this.request.FKIDCustomer = this.customer.IDCustomer;
                    // I dati anagrafici restano sul customer; non li copiamo più sulla pratica.
                    const driveFolderName = this.getCustomerDriveFolderName();

                    const onSimplifiedStep0Done = (success: boolean) => {
                        if (!success) {
                            this.failStepAdvance('Impossibile completare il salvataggio della pratica. Riprova.');
                            return;
                        }
                        this.advanceProgressStatus();
                    };

                    const continueSimplifiedStep0 = () => {
                        if ((this.request.FKIDRequestType === 6 || this.request.FKIDRequestType === 7) && this.customer.IDCustomer) {
                            this.requestService.getByIDCustomer(this.customer.IDCustomer.toString())
                                .subscribe({
                                    next: (requests: Array<Request>) => {
                                        const previousType67Request = this.getLatestType67Request(requests);
                                        if (previousType67Request) {
                                            this.copySimplifiedType67FieldsFrom(previousType67Request);
                                        }
                                        this.proceedSimplifiedStep0(driveFolderName, onSimplifiedStep0Done);
                                    },
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                        this.proceedSimplifiedStep0(driveFolderName, onSimplifiedStep0Done);
                                    }
                                });
                        } else {
                            this.proceedSimplifiedStep0(driveFolderName, onSimplifiedStep0Done);
                        }
                    };

                    // Bilancio/ULA variati: aggiorna ULALastBalance sul customer (già bound in UI)
                    if (this.simplifiedRequestSteps.lastBalance) {
                        this.customerService.update(this.customer)
                            .subscribe({
                                next: () => continueSimplifiedStep0(),
                                error: (err: HttpErrorResponse) => {
                                    console.log(err);
                                    continueSimplifiedStep0();
                                }
                            });
                    } else {
                        continueSimplifiedStep0();
                    }
                } else {
                    console.log('[DEBUG][goStepForward case 0] stato customer al click:', JSON.parse(JSON.stringify(this.customer)));
                    console.log('[DEBUG][goStepForward case 0] visuraParsingResult:', this.visuraParsingResult ? JSON.parse(JSON.stringify(this.visuraParsingResult)) : null);
                    // Chiude lo step 0 salvando DataVariation e avanza SOLO se `success` è true:
                    // in caso contrario i dati della visura/cliente non sono garantiti persistiti
                    // e non deve essere possibile proseguire con la pratica.
                    const finishVisuraStep0 = (success: boolean, errorMessage?: string) => {
                        if (!success) {
                            this.failStepAdvance(errorMessage || 'Impossibile salvare la visura camerale. Riprova.');
                            return;
                        }
                        this.request.DataVariation = this.simplifiedRequestSteps.step3;
                        this.requestService.update(this.request)
                            .subscribe({
                                next: () => this.advanceProgressStatus(),
                                error: (err: HttpErrorResponse) => {
                                    console.log(err);
                                    this.failStepAdvance('Impossibile salvare la pratica. Riprova.');
                                }
                            });
                    };

                    const proceedWithVisuraStep0 = (customerPersisted: boolean) => {
                        if (!customerPersisted) {
                            this.failStepAdvance('Impossibile salvare i dati del cliente estratti dalla visura. Riprova.');
                            return;
                        }

                        if (this.visuraParsingResult !== null) {
                            const driveFolderName = this.getCustomerDriveFolderName();
                            const vatForFilePath = this.customer.VATNumber || '';
                            if (this.request.FKIDRequestType !== 5 && this.request.FKIDRequestType !== 6) {
                                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                                    .subscribe({
                                        next: (folderCreated: any) => {
                                            this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                                            this.requestService.update(this.request)
                                                .subscribe({
                                                    next: () => {
                                                        // Upload visura camerale
                                                        this.fileData[1].append('uploadFile', this.fileVisuraStep1);
                                                        this.fileName[1] = this.fileVisuraStep1!.name;

                                                        this.fileData[1].set('IDDocumentType', '1');
                                                        this.fileData[1].set('IDRequest', this.request.IDRequest!.toString());
                                                        this.fileData[1].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
                                                        if (this.request.FKIDCustomer) {
                                                            this.fileData[1].set('IDCustomer', this.request.FKIDCustomer.toString());
                                                        }
                                                        let fileNameParts: Array<string> = this.fileName[1].split(".");
                                                        this.fileData[1].set('FilePath', this.documentTypeName[1] + '---' +
                                                            vatForFilePath + '_' + this.request.IDRequest!.toString() + '.' + fileNameParts[fileNameParts.length - 1]);
                                                        this.documentService.create(this.fileData[1])
                                                            .subscribe({
                                                                next: ((documentsCreated: any) => {
                                                                    this.documentList[1].push(...documentsCreated);
                                                                    this.fileData[1] = new FormData();
                                                                    this.fileName[1] = '';
                                                                    this.refreshDocumentList();
                                                                    finishVisuraStep0(true);
                                                                }),
                                                                error: ((err: HttpErrorResponse) => {
                                                                    console.log(err);
                                                                    finishVisuraStep0(false);
                                                                })
                                                            });
                                                    },
                                                    error: (err: HttpErrorResponse) => {
                                                        console.log(err);
                                                        finishVisuraStep0(false);
                                                    }
                                                });
                                        },
                                        error: (err: HttpErrorResponse) => {
                                            console.log(err);
                                            finishVisuraStep0(false, 'Impossibile creare la cartella Google Drive della pratica.');
                                        }
                                    });
                            } else if (this.request.FKIDRequestType === 5) {
                                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType)
                                    .subscribe({
                                        next: (folderCreated: any) => {
                                            this.googleDriveService.createFolder(folderCreated.IDFolder, "Documenti caricati dai professionisti", this.request.FKIDRequestType!)
                                                .subscribe({
                                                    next: (folderProfessionalsCreated: any) => {
                                                        this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                                                        this.request.IDFolderGoogleDriveSecondary = folderProfessionalsCreated.IDFolder;
                                                        this.requestService.update(this.request)
                                                            .subscribe({
                                                                next: () => {
                                                                    // Upload visura camerale
                                                                    this.fileData[1].append('uploadFile', this.fileVisuraStep1);
                                                                    this.fileName[1] = this.fileVisuraStep1!.name;

                                                                    this.fileData[1].set('IDDocumentType', '1');
                                                                    this.fileData[1].set('IDRequest', this.request.IDRequest!.toString());
                                                                    this.fileData[1].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
                                                                    if (this.request.FKIDCustomer) {
                                                                        this.fileData[1].set('IDCustomer', this.request.FKIDCustomer.toString());
                                                                    }
                                                                    let fileNameParts: Array<string> = this.fileName[1].split(".");
                                                                    this.fileData[1].set('FilePath', this.documentTypeName[1] + '---' +
                                                                        vatForFilePath + '_' + this.request.IDRequest!.toString() + '.' + fileNameParts[fileNameParts.length - 1]);
                                                                    this.documentService.create(this.fileData[1])
                                                                        .subscribe({
                                                                            next: ((documentsCreated: any) => {
                                                                                this.documentList[1].push(...documentsCreated);
                                                                                this.fileData[1] = new FormData();
                                                                                this.fileName[1] = '';
                                                                                this.refreshDocumentList();
                                                                                finishVisuraStep0(true);
                                                                            }),
                                                                            error: ((err: HttpErrorResponse) => {
                                                                                console.log(err);
                                                                                finishVisuraStep0(false);
                                                                            })
                                                                        });
                                                                },
                                                                error: (err: HttpErrorResponse) => {
                                                                    console.log(err);
                                                                    finishVisuraStep0(false);
                                                                }
                                                            });
                                                    },
                                                    error: (err: HttpErrorResponse) => {
                                                        console.log(err);
                                                        finishVisuraStep0(false, 'Impossibile creare la cartella Google Drive dei professionisti.');
                                                    }
                                                });
                                        },
                                        error: (err: HttpErrorResponse) => {
                                            console.log(err);
                                            finishVisuraStep0(false, 'Impossibile creare la cartella Google Drive della pratica.');
                                        }
                                    });
                            } else if (this.request.FKIDRequestType === 6) {
                                this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                                    .subscribe({
                                        next: (folderCreated: any) => {
                                            this.request.IDFolderGoogleDrive = folderCreated.IDFolderDNS;
                                            this.request.IDFolderGoogleDriveSecondary = folderCreated.IDFolderIP4;
                                            this.requestService.update(this.request)
                                                .subscribe({
                                                    next: () => {
                                                        // Upload visura camerale
                                                        this.fileData[1].append('uploadFile', this.fileVisuraStep1);
                                                        this.fileName[1] = this.fileVisuraStep1!.name;

                                                        this.fileData[1].set('IDDocumentType', '1');
                                                        this.fileData[1].set('IDRequest', this.request.IDRequest!.toString());
                                                        this.fileData[1].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
                                                        if (this.request.FKIDCustomer) {
                                                            this.fileData[1].set('IDCustomer', this.request.FKIDCustomer.toString());
                                                        }
                                                        let fileNameParts: Array<string> = this.fileName[1].split(".");
                                                        this.fileData[1].set('FilePath', this.documentTypeName[1] + '---' +
                                                            vatForFilePath + '_' + this.request.IDRequest!.toString() + '.' + fileNameParts[fileNameParts.length - 1]);
                                                        this.documentService.create(this.fileData[1])
                                                            .subscribe({
                                                                next: ((documentsCreated: any) => {
                                                                    this.documentList[1].push(...documentsCreated);
                                                                    this.fileData[1] = new FormData();
                                                                    this.fileName[1] = '';
                                                                    this.refreshDocumentList();
                                                                    finishVisuraStep0(true);
                                                                }),
                                                                error: ((err: HttpErrorResponse) => {
                                                                    console.log(err);
                                                                    finishVisuraStep0(false);
                                                                })
                                                            });
                                                    },
                                                    error: (err: HttpErrorResponse) => {
                                                        console.log(err);
                                                        finishVisuraStep0(false);
                                                    }
                                                });
                                        },
                                        error: (err: HttpErrorResponse) => {
                                            console.log(err);
                                            finishVisuraStep0(false, 'Impossibile creare la cartella Google Drive della pratica.');
                                        }
                                    });
                            }
                        } else {
                            // Nessun nuovo file di visura da caricare in questo passaggio (es. documento già presente).
                            finishVisuraStep0(true);
                        }
                    };

                    // P.IVA trovata + dati societari variati: aggiorna il customer con i dati della visura
                    if (this.simplifiedRequestSteps.step1 &&
                        this.simplifiedRequestSteps.step2 === 1 &&
                        this.simplifiedRequestSteps.step3 &&
                        this.simplifiedRequestSteps.customerFound) {
                        this.updateFoundCustomerFromVisura(proceedWithVisuraStep0);
                    } else {
                        // Cliente nuovo: crea subito il customer, poi cartella Drive + upload visura
                        this.ensureCustomerPersistedFromStep0(proceedWithVisuraStep0);
                    }
                }
                return;
            case 1:
                if (this.request.Simplified) {
                    this.request.ProgressStatus++;
                }
                break;
            case 2:
                this.saveCustomerFromStep2(() => {
                    const driveFolderName = this.getCustomerDriveFolderName();
                    if (this.request.IDFolderGoogleDrive === null || this.request.IDFolderGoogleDrive === '') {
                        if (this.request.FKIDRequestType !== 5 && this.request.FKIDRequestType !== 6) {
                            this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                                .subscribe({
                                    next: (folderCreated: any) => {
                                        this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                                        this.requestService.update(this.request)
                                            .subscribe({
                                                error: (err: HttpErrorResponse) => {
                                                    console.log(err);
                                                }
                                            });
                                    },
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                    }
                                });
                        } else if (this.request.FKIDRequestType === 5) {
                            this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType)
                                .subscribe({
                                    next: (folderCreated: any) => {
                                        this.googleDriveService.createFolder(folderCreated.IDFolder, "Documenti caricati dai professionisti", this.request.FKIDRequestType!)
                                            .subscribe({
                                                next: (folderProfessionalsCreated: any) => {
                                                    this.request.IDFolderGoogleDrive = folderCreated.IDFolder;
                                                    this.request.IDFolderGoogleDriveSecondary = folderProfessionalsCreated.IDFolder;
                                                    this.requestService.update(this.request)
                                                        .subscribe({
                                                            error: (err: HttpErrorResponse) => {
                                                                console.log(err);
                                                            }
                                                        });
                                                },
                                                error: (err: HttpErrorResponse) => {
                                                    console.log(err);
                                                }
                                            });
                                    },
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                    }
                                });
                        } else if (this.request.FKIDRequestType === 6) {
                            this.googleDriveService.createFolder(null, driveFolderName, this.request.FKIDRequestType!)
                                .subscribe({
                                    next: (folderCreated: any) => {
                                        this.request.IDFolderGoogleDrive = folderCreated.IDFolderDNS;
                                        this.request.IDFolderGoogleDriveSecondary = folderCreated.IDFolderIP4;
                                        this.requestService.update(this.request)
                                            .subscribe({
                                                error: (err: HttpErrorResponse) => {
                                                    console.log(err);
                                                }
                                            });
                                    },
                                    error: (err: HttpErrorResponse) => {
                                        console.log(err);
                                    }
                                });
                        }
                    } else {
                        this.requestService.update(this.request)
                            .subscribe({
                                error: (err: HttpErrorResponse) => {
                                    console.log(err);
                                }
                            });
                    }
                });
                break;
            case 3:
                let requestInvestmentType: string[] = [];
                this.checkboxInvestmentTypeValues.forEach((checkboxInvestmentTypeValue: boolean, index: number) => {
                    if (checkboxInvestmentTypeValue) requestInvestmentType.push(this.checkboxInvestmentTypeOptions[index]);
                });
                this.request.InvestmentType = requestInvestmentType.join(",");
                this.syncInvestmentAmountFromDisplay(true);
                break;
            case 4:
                this.request.WarrantAcceptance = true;
                if (this.request.FKIDRequestType === 5) {
                    this.request.ProgressStatus = 7;
                }
                break;
            case 5:
                this.request.AttorneyAcceptance = true;
                if (this.isRequestType7()) {
                    // Per il tipo richiesta 7, Procura (6) e Privacy (7) vengono saltati.
                    this.request.ReleaseAcceptance = true;
                    this.request.PrivacyAcceptance = true;
                    this.request.ProgressStatus = 7;
                }
                break;
            case 6:
                this.request.ReleaseAcceptance = true;
                break;
            case 7:
                this.request.PrivacyAcceptance = true;
                break;
            case 8:
                if (this.request.CompanyParticipation || this.request.PartnersParticipation) {
                    this.emailService.sendDimensionalProspectus(this.request.IDRequest!)
                        .subscribe({
                            error: (err: HttpErrorResponse) => {
                                console.log(err);
                            }
                        });
                }

                this.documentService.uploadExportFile(this.request.IDRequest!.toString())
                    .subscribe({
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });

                this.generateRecapDocument();
                break;
        }
        this.advanceProgressStatus();
    }

    /** Incrementa ProgressStatus e persiste la pratica. Da chiamare solo dopo che gli eventuali
     * salvataggi asincroni dello step corrente sono andati a buon fine. */
    private advanceProgressStatus(): void {
        this.request.ProgressStatus++;
        this.requestService.update(this.request)
            .subscribe({
                next: () => {
                    this.loadingCondition = false;
                    this.stepAdvanceError = null;
                    if (this.request.ProgressStatus === 8) {
                        this.onEnterStep8();
                    }
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                }
            });
    }

    /** Blocca l'avanzamento dello step corrente e mostra all'utente il motivo del fallimento. */
    private failStepAdvance(message: string): void {
        this.loadingCondition = false;
        this.stepAdvanceError = message;
    }

    goStepForwardInfo() {
        this.hyperDepreciationStep = true;
    }

    goStepBackwardInfo() {
        this.hyperDepreciationStep = false;
    }

    goStepForwardContract() {
        this.hyperDepreciationContractStep = true;
    }

    goStepBackwardContract() {
        this.hyperDepreciationContractStep = false;
    }

    goStepBackward() {
        if (this.request.ProgressStatus === 8 && this.request.FKIDRequestType === 5) {
            this.request.ProgressStatus = 5;
        }
        if (this.request.ProgressStatus === 8 && this.request.FKIDRequestType === 7) {
            this.request.ProgressStatus = 6;
        }
        if (this.request.ProgressStatus === 2 && this.request.FKIDRequestType === 5) {
            this.startingVideoShow = true;
        }

        if (this.request.ProgressStatus === 3 && this.request.Simplified) {
            this.request.ProgressStatus = 2;
        }

        this.syncDepreciationBeforeSave();
        this.request.ProgressStatus--;
        this.requestService.update(this.request)
            .subscribe({
                next: () => {},
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    private markVATNumberNotFound(): void {
        this.simplifiedRequestSteps.step2 = -1;
        this.simplifiedRequestSteps.customerFound = null;
        const vatNumber = this.customer.VATNumber || '';
        this.customer = new Customer();
        this.customer.VATNumber = vatNumber;
    }

    checkVATNumber() {
        this.customerService.getByVATNumber(this.customer.VATNumber)
            .subscribe({
                next: (foundCustomer: Customer) => {
                    if (!foundCustomer?.IDCustomer) {
                        this.markVATNumberNotFound();
                        return;
                    }

                    // Il cliente si riaggancia solo dalla P.IVA, anche se non ha pratiche concluse.
                    this.simplifiedRequestSteps.step2 = 1;
                    this.simplifiedRequestSteps.customerFound = foundCustomer;
                    this.customer = foundCustomer;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    // 404 / nessun customer con quella P.IVA
                    this.markVATNumberNotFound();
                }
            });
    }

    downloadDocumentsToSign() {
        this.triggerDocumentsToSignDownload();
    }

    uploadDocument(event: any, idDocumentType: number) {
        if (this.loadingCondition) {
            return;
        }
        this.loadingCondition = true;
        const files: Array<File> = event.target.files;
        if (files.length === 0) {
            this.loadingCondition = false;
            return;
        }

        this.fileData[idDocumentType] = new FormData();
        for (let i = 0; i < files.length; i++) {
            this.fileData[idDocumentType].append('uploadFile', files[i]);
        }
        this.fileName[idDocumentType] = (files.length === 1) ? files[0].name : files.length + ' file selezionati';

        this.createDocument(idDocumentType);
    }

    onLastBalanceStep1FileSelected(event: any) {
        const file: File | undefined = event.target.files?.[0];
        if (!file) {
            this.fileLastBalanceStep1 = null;
            this.fileName[2] = '';
            this.fileData[2] = new FormData();
            return;
        }

        this.fileLastBalanceStep1 = file;
        this.fileName[2] = file.name;
        this.fileData[2] = new FormData();
        this.fileData[2].append('uploadFile', file);
    }

    private createDocument(idDocumentType: number) {
        if (!this.fileData[idDocumentType]?.has('uploadFile')) {
            this.loadingCondition = false;
            return;
        }

        this.loadingCondition = true;
        let documentIncrementalPart = '';
        if (idDocumentType === 4 || idDocumentType === 5) {
            let maxDocumentIndex = 0;
            this.documentList[idDocumentType].forEach((currentDocument: any)=> {
                let currentDocumentPathParts = currentDocument.Path.split("---")[0].split("_");
                let currentDocumentIndex = parseInt(currentDocumentPathParts[currentDocumentPathParts.length - 1]);
                if (currentDocumentIndex > maxDocumentIndex) {
                    maxDocumentIndex = currentDocumentIndex;
                }
            });
            documentIncrementalPart = "_" + (maxDocumentIndex + 1);
        }

        this.fileData[idDocumentType].set('IDDocumentType', idDocumentType.toString());
        this.fileData[idDocumentType].set('IDRequest', this.request.IDRequest!.toString());
        this.fileData[idDocumentType].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
        if (isCustomerDocumentType(idDocumentType) && this.request.FKIDCustomer) {
            this.fileData[idDocumentType].set('IDCustomer', this.request.FKIDCustomer.toString());
        }

        const firstFile = this.fileData[idDocumentType].getAll('uploadFile')[0] as File;
        const fileNameParts: Array<string> = (firstFile?.name || this.fileName[idDocumentType] || '').split(".");
        const extension = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : '';

        const vatForFilePath = this.customer?.VATNumber || '';
        this.fileData[idDocumentType].set('FilePath', this.documentTypeName[idDocumentType] + documentIncrementalPart + '---' +
            vatForFilePath + '_' + this.request.IDRequest!.toString() + (extension ? '.' + extension : ''));

        this.documentService.create(this.fileData[idDocumentType])
            .subscribe({
                next: ((documentsCreated: any) => {
                    if (!this.documentList[idDocumentType]) {
                        this.documentList[idDocumentType] = [];
                    }
                    // Per i tipi cliente la create risponde con il master, che qui non va mostrato:
                    // la riga giusta è il satellite e arriva dal refresh.
                    if (isCustomerDocumentType(idDocumentType)) {
                        this.refreshDocumentList();
                    } else {
                        this.documentList[idDocumentType].push(...documentsCreated);
                    }
                    this.fileData[idDocumentType] = new FormData();
                    this.fileName[idDocumentType] = '';
                    if (idDocumentType === 2) {
                        this.fileLastBalanceStep1 = null;
                    }
                    this.loadingCondition = false;
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                })
            });
    }

    deleteDocument(document: Document) {
        this.loadingCondition = true;
        this.documentService.deleteRequestDocument(document.IDDocument)
            .subscribe({
                next: (() => {
                    this.documentList[document.FKIDDocumentType!] = this.documentList[document.FKIDDocumentType!].filter((currentDocument: Document) => {
                       return document.IDDocument !== currentDocument.IDDocument;
                    });
                    this.loadingCondition = false;
                    if (isCustomerDocumentType(document.FKIDDocumentType)) {
                        this.refreshDocumentList();
                    }
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                })
            });
    }

    valueChangeInvestmentType(investmentTypeIndex: number) {
        this.checkboxInvestmentTypeValues[investmentTypeIndex] = !this.checkboxInvestmentTypeValues[investmentTypeIndex];

        if (investmentTypeIndex === 3 && this.checkboxInvestmentTypeValues[investmentTypeIndex]) {
            this.openVideoModal(7);
        }
    }

    onInvestmentAmountKeyDown(event: KeyboardEvent): void {
        const inputEl = event.target as HTMLInputElement | null;
        if (!inputEl) {
            return;
        }
        const start = inputEl.selectionStart;
        const end = inputEl.selectionEnd;
        if (start === null || end === null || start !== end) {
            return;
        }

        // Se l'utente preme Backspace subito dopo un punto delle migliaia (es. "10.|000,00"),
        // salta il punto e cancella direttamente la cifra a sinistra del punto.
        if (event.key === 'Backspace' && start > 0 && inputEl.value[start - 1] === '.') {
            inputEl.setSelectionRange(start - 1, start - 1);
        } else if (event.key === 'Delete' && start < inputEl.value.length && inputEl.value[start] === '.') {
            inputEl.setSelectionRange(start + 1, start + 1);
        }
    }

    onInvestmentAmountInput(event?: Event): void {
        const inputEl = event?.target as HTMLInputElement | null | undefined;
        const raw = inputEl?.value ?? this.investmentAmountDisplay;
        const rawCaret = inputEl?.selectionStart ?? raw.length;
        const inputData = (event as InputEvent | undefined)?.data;

        let newlyTypedDecimalIndex: number | null = null;
        if (inputData === '.' || inputData === ',') {
            newlyTypedDecimalIndex = rawCaret > 0
                ? rawCaret - 1
                : raw.lastIndexOf(inputData);
        }

        const formatted = formatItalianAmountWhileTyping(
            raw,
            this.previousInvestmentAmountDisplay,
            newlyTypedDecimalIndex
        );
        const nextCaret = computeFormattedCaretPosition(
            raw,
            rawCaret,
            formatted,
            this.previousInvestmentAmountDisplay,
            newlyTypedDecimalIndex
        );

        this.investmentAmountDisplay = formatted;
        this.previousInvestmentAmountDisplay = formatted;
        this.request.InvestmentAmount = parseItalianAmountToNumber(formatted);
        if (inputEl) {
            if (inputEl.value !== formatted) {
                inputEl.value = formatted;
            }
            inputEl.setSelectionRange(nextCaret, nextCaret);
            setTimeout(() => {
                if (document.activeElement === inputEl) {
                    inputEl.setSelectionRange(nextCaret, nextCaret);
                }
            });
        }
    }

    onInvestmentAmountBlur(): void {
        this.syncInvestmentAmountFromDisplay(true);
    }

    private syncInvestmentAmountFromDisplay(finalizeOnBlur: boolean): void {
        if (finalizeOnBlur) {
            this.investmentAmountDisplay = finalizeItalianAmountOnBlur(this.investmentAmountDisplay);
        }
        this.previousInvestmentAmountDisplay = this.investmentAmountDisplay;
        this.request.InvestmentAmount = parseItalianAmountToNumber(this.investmentAmountDisplay);
    }

    onPasteIBAN(event: any) {
        let ibanPasted = event.clipboardData.getData('text');
        ibanPasted = ibanPasted.replace(/ /g, "");
        ibanPasted = ibanPasted.substring(0, 27).toUpperCase();
        this.customer.IBAN = ibanPasted;
    }

    onChangeIBAN(event: any) {
        this.customer.IBAN = event.replace(/ /g, "").toUpperCase();
    }

    openInfoPaymentModal() {
        let paymentDetailsText = '';
        if (this.request.PaymentDetails !== null && this.request.PaymentDetails !== '') {
            paymentDetailsText = this.request.PaymentDetails;
        } else {
            const formatEuroNumber = (valore: number) => new Intl.NumberFormat('it-IT', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(valore);

            if (this.request.FKIDRequestType === 1) {
                paymentDetailsText = "Il costo è pari a " + formatEuroNumber(this.request.PaymentCost1) + " euro (più oneri di legge) divisi in " + formatEuroNumber(this.request.PaymentCost1 / 2) + " euro (1° parte) e " + formatEuroNumber(this.request.PaymentCost1 / 2) + " euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di " + formatEuroNumber((this.request.PaymentCost1 / 2) * 1.22) + " euro (" + formatEuroNumber(this.request.PaymentCost1 / 2) + " euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento \"Domanda Nuova Sabatini\" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.";
            } else if (this.request.FKIDRequestType === 6) {
                const paymentCostTotal = +(this.request.PaymentCost1 + this.request.PaymentCost2);
                paymentDetailsText = "Il costo è pari a " + formatEuroNumber(paymentCostTotal) + " euro (più oneri di legge) divisi in " + formatEuroNumber(paymentCostTotal / 2) + " euro (1° parte) e " + formatEuroNumber(paymentCostTotal / 2) + " euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di " + formatEuroNumber((paymentCostTotal / 2) * 1.22) + " euro (" + formatEuroNumber(paymentCostTotal / 2) + " euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento \"Domanda Nuova Sabatini e Iperammortamento 4.0\" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.";
            } else if (this.request.FKIDRequestType === 7) {
                paymentDetailsText = "Il costo è pari a " + formatEuroNumber(this.request.PaymentCost2) + " euro (più oneri di legge) divisi in " + formatEuroNumber(this.request.PaymentCost2 / 2) + " euro (1° parte) e " + formatEuroNumber(this.request.PaymentCost2 / 2) + " euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di " + formatEuroNumber(((this.request.PaymentCost2 / 2) * 1.22)) + " euro (" + formatEuroNumber(this.request.PaymentCost2 / 2) + " euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento \"Iperammortamento 4.0\" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.";
            }
        }
        const modalRef = this.modalService.open(RequestInfoPaymentModalComponent);
        modalRef.componentInstance.paymentDetails = paymentDetailsText;
    }

    openVideoModal(idVideo: number) {
        const modalRef = this.modalService.open(VideoModalComponent, { size: 'lg' });
        modalRef.componentInstance.idVideo = idVideo;
    }

    getPrice(text: string): string {
        const regex = /\d+,\d{2}\s*euro/; 
        const match = text.match(regex);
        return match ? match[0] : '';
      }

    async onVisuraFileSelected(event: any) {
        this.visuraParsingResult = null;
        const file: File = event.target.files[0];
        this.fileVisuraStep1 = file;
        if (!file) {
          console.log('Nessun file selezionato');
          return;
        }

        // Cliente nuovo: assicurati di scrivere su un customer locale (senza ID)
        if (!this.simplifiedRequestSteps.step1 && this.customer.IDCustomer) {
            this.customer = new Customer();
        }
      
        try {
            this.fileName[1] = this.fileVisuraStep1!.name;
            const arrayBuffer = await file.arrayBuffer();
            const loadingTask = pdfjsLib.getDocument(arrayBuffer);
            const pdf = await loadingTask.promise;
            const totalPages = pdf.numPages;
        
            const page = await pdf.getPage(1);
            const content = await page.getTextContent();
            const text = content.items.map((item: any) => item.str).join(' ');
      
            // Parsing dei campi chiave con regex
            const success: any[] = [];
            const errors: string[] = [];

            // 1. CompanyName: VISURA ORDINARIA SOCIETA' DI CAPITALE
            const normalizedText = text.replace(/\s+/g, ' ').trim();
            let companyNameMatch = normalizedText.match(/VISURA ORDINARIA SOCIETA' DI CAPITALE\s+([\s\S]+?)\s+[A-Z0-9]{5,}\s+Il QR Code/i);
            if (!companyNameMatch) {
                companyNameMatch = normalizedText.match(/VISURA ORDINARIA SOCIETA' DI PERSONE\s+([\s\S]+?)\s+[A-Z0-9]{5,}\s+Il QR Code/i);
            }
            if (!companyNameMatch) {
                companyNameMatch = normalizedText.match(/VISURA ORDINARIA DELL'IMPRESA\s+([\s\S]+?)\s+[A-Z0-9]{5,}\s+Il QR Code/i);
            }
            if (!companyNameMatch) {
                companyNameMatch = normalizedText.match(/VISURA STORICA DELL'IMPRESA\s+([\s\S]+?)\s+[A-Z0-9]{5,}\s+Il QR Code/i);
            }
            if (companyNameMatch) {
                this.customer.CompanyName = companyNameMatch[1].replace(/"/g, '').trim();
                success.push({
                    'title': 'Denominazione società',
                    'key': 'CompanyName',
                    'value': this.customer.CompanyName
                });
            } else {
                errors.push('Denominazione società');
            }

            // 2,3,4,5 Sede legale, Provincia, Indirizzo e Numero Civico
            const addressSectionMatch1 = normalizedText.match(/Indirizzo Sede legale\s+(.+?)\s+CAP\s+\d{5}/i);
            const addressSectionMatch2 = normalizedText.match(/Indirizzo Sede\s+(.+?)\s+CAP\s+\d{5}/i);
            let addressSectionMatch = null;
            if (addressSectionMatch1) {
                addressSectionMatch = addressSectionMatch1;
            } else if (addressSectionMatch2) {
                addressSectionMatch = addressSectionMatch2;
            }

            if (addressSectionMatch) {
                const addressSection = addressSectionMatch[1].trim();

                // Usa regex per città, provincia, indirizzo e numero civico sulla sezione
                const addressRegex = /^(.+?)\s*\(\s*([^)]+?)\s*\)\s*(.+?)\s+(\S+)$/i;
                const addressMatch = addressSection.match(addressRegex);

                if (addressMatch) {
                    this.customer.HeadOffice = addressMatch[1].trim();
                    this.customer.HeadOfficeProvince = addressMatch[2].trim();
                    this.customer.Address = addressMatch[3].trim();
                    this.customer.HouseNumber = addressMatch[4].trim();
                    success.push({
                        'title': 'Sede legale',
                        'key': 'HeadOffice',
                        'value': this.customer.HeadOffice
                    });
                    success.push({
                        'title': 'Provincia Sede legale',
                        'key': 'HeadOfficeProvince',
                        'value': this.customer.HeadOfficeProvince
                    });
                    success.push({
                        'title': 'Indirizzo',
                        'key': 'Address',
                        'value': this.customer.Address
                    });
                    success.push({
                        'title': 'Numero civico',
                        'key': 'HouseNumber',
                        'value': this.customer.HouseNumber
                    });
                } else {
                    errors.push('Indirizzo sede legale');
                    console.warn("Regex indirizzo non ha trovato corrispondenza.");
                }
            } else {
                errors.push('Indirizzo sede legale');
                console.warn("Sezione 'Indirizzo Sede legale' non trovata nel testo.");
            }

            // 6. Partita IVA
            const vatNumberMatch = normalizedText.match(/Partita IVA\s+(\d{11})/i);
            if (vatNumberMatch) {
                this.customer.VATNumber = vatNumberMatch[1];
                success.push({
                    'title': 'Partita IVA',
                    'key': 'VATNumber',
                    'value': this.customer.VATNumber
                });
            } else {
                errors.push('Partita IVA');
            }

            // 7. Legale rappresentante
            let representativeMatch1 = normalizedText.match(/(?:[a-z]+(?:\s+))+([\p{Lu}\p{M}&.\s]+?)\s+Rappresentante dell'Impresa/u);
            let representativeMatch2 = normalizedText.match(/Titolare di impresa individuale\s+(.*?)\s+(?:Rappresentante|ATTIVITA)/i);
            let representativeMatch3 = normalizedText.match(/Amministratore Unico\s+(.*?)\s+(?:Rappresentante|ATTIVITA)/i);

            let representativeMatch = null;
            if (representativeMatch1) {
                representativeMatch = representativeMatch1;
            } else if (representativeMatch2) {
                representativeMatch = representativeMatch2;
            } else if (representativeMatch3) {
                representativeMatch = representativeMatch3;
            }

            if (representativeMatch && representativeMatch[1]) {
                let representativeFullName = representativeMatch[1].trim().split(/[, ]+/);
                const representativeName = representativeFullName.pop();
                const representativeSurname = representativeFullName.join(' ');
                
                this.customer.Name = representativeName !== undefined ? representativeName : '';
                this.customer.Surname = representativeSurname !== undefined ? representativeSurname : '';
                success.push({
                    'title': 'Nome legale rappresentante',
                    'key': 'Name',
                    'value': this.customer.Name
                });
                success.push({
                    'title': 'Cognome legale rappresentante',
                    'key': 'Surname',
                    'value': this.customer.Surname
                });
            } else {
                errors.push('Legale rappresentante');
            }

            let pageFound = false;
            let pageCounter = 2;
            
            while (!pageFound && pageCounter < totalPages) {
                const currentPage = await pdf.getPage(pageCounter);
                const contentCurrentPage = await currentPage.getTextContent();
                const textCurrentPage = contentCurrentPage.items.map((item: any) => item.str).join(' ');
                const normalizedTextCurrentPage = textCurrentPage.replace(/\s+/g, ' ').trim();

                // 8. Dati legale rappresentante
                if (normalizedTextCurrentPage.includes('Rappresentante dell\'impresa Nat') || normalizedTextCurrentPage.includes('Titolare Firmatario ' + this.customer.Surname + ' ' + this.customer.Name + ' Nat') || normalizedTextCurrentPage.includes('Amministratore Unico ' + this.customer.Surname + ' ' + this.customer.Name + ' Nat')) {
                    pageFound = true;

                    const luogoNascitaMatch = normalizedTextCurrentPage.match(/Nat[ao] a ([A-Za-zÀ-ÿ' ]+?)(?= \(([A-Z]{2})\)| [A-ZÀ-ÿ]+ il| il)/);
                    const provinciaStatoNascitaMatch = normalizedTextCurrentPage.match(/Nat[ao] a [A-Za-zÀ-ÿ' ]+(?: \(([A-Z]{2})\)| ([A-ZÀ-ÿ]+))/);
                    const dataNascitaMatch = normalizedTextCurrentPage.match(/il (\d{2}\/\d{2}\/\d{4})/);
                    const residenzaLegaleMatch1 = normalizedTextCurrentPage.match(/domicilio ([A-Za-zÀ-ÿ' ]+) \(/);
                    const residenzaLegaleMatch2 = normalizedTextCurrentPage.match(/residenza ([A-Za-zÀ-ÿ' ]+) \(/);
                    let residenzaLegaleMatch = null;
                    if (residenzaLegaleMatch1) {
                        residenzaLegaleMatch = residenzaLegaleMatch1;
                    } else if (residenzaLegaleMatch2) {
                        residenzaLegaleMatch = residenzaLegaleMatch2;
                    }
                    const provinciaResidenzaMatch1 = normalizedTextCurrentPage.match(/domicilio [A-Za-zÀ-ÿ' ]+ \(([A-Z]{2})\)/);
                    const provinciaResidenzaMatch2 = normalizedTextCurrentPage.match(/residenza [A-Za-zÀ-ÿ' ]+ \(([A-Z]{2})\)/);
                    let provinciaResidenzaMatch = null;
                    if (provinciaResidenzaMatch1) {
                        provinciaResidenzaMatch = provinciaResidenzaMatch1;
                    } else if (provinciaResidenzaMatch2) {
                        provinciaResidenzaMatch = provinciaResidenzaMatch2;
                    }

                    if (luogoNascitaMatch) {
                        this.customer.BirthPlace = luogoNascitaMatch[1].trim();
                        success.push({
                            'title': 'Luogo nascita legale rappresentante',
                            'key': 'BirthPlace',
                            'value': this.customer.BirthPlace
                        });
                    } else {
                        errors.push('Luogo nascita legale rappresentante');
                    }
                    if (provinciaStatoNascitaMatch) {
                        this.customer.BirthPlaceProvince = provinciaStatoNascitaMatch[1] || provinciaStatoNascitaMatch[2];
                        success.push({
                            'title': 'Provincia/Stato nascita legale rappresentante',
                            'key': 'BirthPlaceProvince',
                            'value': this.customer.BirthPlaceProvince
                        });
                    } else {
                        errors.push('Provincia/Stato nascita legale rappresentante');
                    }
                    if (dataNascitaMatch) {
                        const [day, month, year] = dataNascitaMatch[1].trim().split('/');
                        this.customer.BirthDate = new Date(Date.UTC(+year, +month - 1, +day));
                        success.push({
                            'title': 'Data nascita legale rappresentante',
                            'key': 'BirthDate',
                            'value': day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year
                        });
                    } else {
                        errors.push('Data nascita legale rappresentante');
                    }
                    if (residenzaLegaleMatch) {
                        this.customer.City = residenzaLegaleMatch[1].trim();
                        success.push({
                            'title': 'Residenza legale rappresentante',
                            'key': 'City',
                            'value': this.customer.City
                        });
                    } else {
                        errors.push('Residenza legale rappresentante');
                    }
                    if (provinciaResidenzaMatch) {
                        this.customer.Province = provinciaResidenzaMatch[1].trim();
                        success.push({
                            'title': 'Provincia residenza legale rappresentante',
                            'key': 'Province',
                            'value': this.customer.Province
                        });
                    } else {
                        errors.push('Provincia residenza legale rappresentante');
                    }
                }
                pageCounter++;
            }

            // Aggiorna variabile per mostrare risultati a schermo
            this.visuraParsingResult = {
                success,
                errors
            };
        } catch (error) {
          console.error('Errore nel parsing del PDF:', error);
        }
    }

    startEditVisura(visuraSuccess: any) {
        this.editingVisuraField = visuraSuccess.key;
        this.editingVisuraValue = visuraSuccess.value;
    }

    saveEditVisura(visuraSuccess: any) {
        if (this.editingVisuraField && this.visuraParsingResult) {
            // Aggiorna il valore nel risultato del parsing
            const item = this.visuraParsingResult.success.find(item => item.key === this.editingVisuraField);
            if (item) {
                item.value = this.editingVisuraValue;
            }
            
            // Aggiorna il valore corrispondente sul customer di lavoro
            (this.customer as any)[this.editingVisuraField] = this.editingVisuraValue;
            
            // Reset dello stato di modifica
            this.editingVisuraField = null;
            this.editingVisuraValue = '';
        }
    }

    checkCompleteRequest(): boolean {
        if ((this.request.FKIDRequestType === 1 || this.request.FKIDRequestType === 2 || this.request.FKIDRequestType === 3 || this.request.FKIDRequestType === 4) && !this.request.Simplified) {
            return this.documentList['1'].length === 0 ||
                this.documentList['2'].length === 0 ||
                this.documentList['3'].length === 0 ||
                this.documentList['4'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0;
        } else if ((this.request.FKIDRequestType === 1 || this.request.FKIDRequestType === 2 || this.request.FKIDRequestType === 3 || this.request.FKIDRequestType === 4) && this.request.Simplified) {
            return this.documentList['3'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0;
        } else if (this.request.FKIDRequestType === 6 && this.request.Simplified) {
            return this.documentList['3'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0;
        } else if (this.request.FKIDRequestType === 7 && this.request.Simplified) {
            return this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0;
        } else if (this.request.FKIDRequestType === 6) {
            return this.documentList['1'].length === 0 ||
            this.documentList['2'].length === 0 ||
            this.documentList['3'].length === 0 ||
            this.documentList['4'].length === 0 ||
            this.documentList['5'].length === 0 ||
            this.documentList['6'].length === 0 ||
            this.documentList['7'].length === 0 ||
            this.documentList['8'].length === 0 ||
            this.documentList['16'].length === 0 ||
            this.documentList['29'].length === 0;
        } else if (this.request.FKIDRequestType === 7) {
            return this.documentList['1'].length === 0 ||
            this.documentList['2'].length === 0 ||
            this.documentList['4'].length === 0 ||
            this.documentList['5'].length === 0 ||
            this.documentList['6'].length === 0 ||
            this.documentList['7'].length === 0 ||
            this.documentList['8'].length === 0 ||
            this.documentList['16'].length === 0 ||
            this.documentList['29'].length === 0;
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion === 'Sostituzione'
            && this.request.TaxCredit5StructureOwner === 'Affittuaria') {
            return this.documentList['1'].length === 0 ||
                this.documentList['2'].length === 0 ||
                this.documentList['4'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0 ||
                this.documentList['10'].length === 0 ||
                this.documentList['15'].length === 0 ||
                this.documentList['16'].length === 0 ||
                this.documentList['17'].length === 0;
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion === 'Sostituzione'
            && this.request.TaxCredit5StructureOwner !== 'Affittuaria') {
            return this.documentList['1'].length === 0 ||
                this.documentList['2'].length === 0 ||
                this.documentList['4'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0 ||
                this.documentList['10'].length === 0 ||
                this.documentList['15'].length === 0 ||
                this.documentList['16'].length === 0;
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion !== 'Sostituzione'
                && this.request.TaxCredit5StructureOwner === 'Affittuaria') {
            return this.documentList['1'].length === 0 ||
                this.documentList['2'].length === 0 ||
                this.documentList['4'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0 ||
                this.documentList['16'].length === 0 ||
                this.documentList['17'].length === 0;
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion !== 'Sostituzione'
            && this.request.TaxCredit5StructureOwner !== 'Affittuaria') {
            return this.documentList['1'].length === 0 ||
                this.documentList['2'].length === 0 ||
                this.documentList['4'].length === 0 ||
                this.documentList['5'].length === 0 ||
                this.documentList['6'].length === 0 ||
                this.documentList['7'].length === 0 ||
                this.documentList['8'].length === 0 ||
                this.documentList['16'].length === 0;
        } else {
            return true;
        }
    }

    canAdvanceFromCurrentStep(form?: NgForm): boolean {
        if (this.getMissingFieldsForCurrentStep().length > 0) {
            return false;
        }
        if (form && form.invalid) {
            return false;
        }
        return true;
    }

    getMissingFieldsForCurrentStep(): string[] {
        switch (this.request.ProgressStatus) {
            case 0:
                return this.getMissingFieldsStep0();
            case 1:
                return this.getMissingFieldsStep1();
            case 2:
                return this.request.Simplified ? [] : this.getMissingFieldsStep2();
            case 3:
                return this.getMissingFieldsStep3();
            case 5:
                return this.getMissingFieldsStep5();
            case 8:
                return this.getMissingFieldsStep8();
            default:
                return [];
        }
    }

    getMissingFieldsStep0(): string[] {
        const missing: string[] = [];

        if (this.simplifiedRequestSteps.step1 === null || this.simplifiedRequestSteps.step1 === undefined) {
            missing.push('Indicazione pratica Tevanpal precedente');
            return missing;
        }

        if (this.simplifiedRequestSteps.step1 === true) {
            if (this.simplifiedRequestSteps.step2 !== 1) {
                missing.push('Verifica Partita IVA (pratica precedente trovata)');
            }
            if (this.simplifiedRequestSteps.step2 === 1 &&
                (this.simplifiedRequestSteps.step3 === null || this.simplifiedRequestSteps.step3 === undefined)) {
                missing.push('Indicazione variazione dati societari');
            }
            if (this.simplifiedRequestSteps.step2 === 1 && this.simplifiedRequestSteps.step3 === false) {
                if (this.simplifiedRequestSteps.lastBalance === null || this.simplifiedRequestSteps.lastBalance === undefined) {
                    missing.push('Indicazione variazione bilancio/ULA');
                }
                if (this.simplifiedRequestSteps.lastBalance === true) {
                    const ula = this.customer?.ULALastBalance;
                    if (!ula || ula.toString().trim().length === 0) {
                        missing.push('ULA ultimo bilancio');
                    }
                    const hasLastBalanceFile = this.fileLastBalanceStep1 !== null ||
                        this.fileData[2]?.has('uploadFile') ||
                        this.documentList['2'].length > 0;
                    if (!hasLastBalanceFile) {
                        missing.push('Ultimo bilancio approvato');
                    }
                }
            }
        }

        const needsVisura = this.simplifiedRequestSteps.step1 === false || this.simplifiedRequestSteps.step3 === true;
        if (needsVisura) {
            const hasVisuraFile = this.fileVisuraStep1 !== null || this.documentList['1'].length > 0;
            if (!hasVisuraFile) {
                missing.push('Visura camerale aggiornata');
            }
            if (this.visuraParsingResult !== null && !this.checkboxVisuraData) {
                missing.push('Conferma correttezza dati visura');
            }
        }

        return missing;
    }

    getMissingFieldsStep1(): string[] {
        const missing: string[] = [];

        if (this.startingVideoShow) {
            return missing;
        }

        if (this.request.FKIDRequestType === 6) {
            if (this.hyperDepreciationStep) {
                if (!this.checkboxRelease[2]) {
                    missing.push('Accettazione informativa Iperammortamento 4.0');
                }
            } else if (!this.checkboxRelease[0]) {
                missing.push('Accettazione informativa');
            }
            return missing;
        }

        if (this.request.FKIDRequestType === 1 ||
            this.request.FKIDRequestType === 4 ||
            this.request.FKIDRequestType === 7) {
            if (!this.checkboxRelease[0]) {
                missing.push('Accettazione informativa');
            }
        }

        return missing;
    }

    getMissingFieldsStep2(): string[] {
        const missing: string[] = [];
        const customer = this.customer;

        if (!customer.CompanyName || customer.CompanyName.trim().length < 2) {
            missing.push('Ragione Sociale Società / Ditta individuale');
        }
        if (!customer.VATNumber || customer.VATNumber.trim().length < 2) {
            missing.push('Partita IVA');
        }
        if (!customer.HeadOffice || customer.HeadOffice.trim().length < 2) {
            missing.push('Comune sede legale');
        }
        if (!customer.HeadOfficeProvince || customer.HeadOfficeProvince.trim().length !== 2) {
            missing.push('Provincia sede legale');
        }
        if (!customer.Address || customer.Address.trim().length < 2) {
            missing.push('Via sede legale');
        }
        if (!customer.HouseNumber || customer.HouseNumber.toString().trim().length === 0) {
            missing.push('Civico sede legale');
        }

        if (this.request.FKIDRequestType !== 5) {
            if (!customer.IBAN || customer.IBAN.trim().length !== 27) {
                missing.push('IBAN');
            }
            if (!customer.SupportBankName || customer.SupportBankName.trim().length < 2) {
                missing.push('Nome banca di appoggio');
            }
            if (!customer.SupportBankBIC || customer.SupportBankBIC.trim().length < 8) {
                missing.push('BIC banca di appoggio');
            }
        }

        if (!customer.SDICode || customer.SDICode.trim().length !== 7) {
            missing.push('Codice SDI');
        }
        if (!customer.ULALastBalance || customer.ULALastBalance.toString().trim().length === 0) {
            missing.push('ULA ultimo bilancio');
        }
        if (!customer.Phone || customer.Phone.trim().length < 2) {
            missing.push('Numero di telefono fisso');
        }
        if (!customer.MobilePhone || customer.MobilePhone.trim().length < 2) {
            missing.push('Numero di telefono cellulare');
        }
        if (!customer.Name || customer.Name.trim().length < 2) {
            missing.push('Nome legale rappresentante');
        }
        if (!customer.Surname || customer.Surname.trim().length < 2) {
            missing.push('Cognome legale rappresentante');
        }
        if (!customer.BirthPlace || customer.BirthPlace.trim().length < 2) {
            missing.push('Luogo di nascita legale rappresentante');
        }
        if (!customer.BirthPlaceProvince || customer.BirthPlaceProvince.trim().length < 2) {
            missing.push('Provincia luogo di nascita legale rappresentante');
        }
        if (!customer.BirthDate) {
            missing.push('Data di nascita legale rappresentante');
        }
        if (!customer.City || customer.City.trim().length < 2) {
            missing.push('Comune di residenza legale rappresentante');
        }
        if (!customer.Province || customer.Province.trim().length !== 2) {
            missing.push('Provincia di residenza legale rappresentante');
        }

        return missing;
    }

    getMissingFieldsStep3(): string[] {
        const missing: string[] = [];

        if (this.request.CompanyParticipation === null || this.request.CompanyParticipation === undefined) {
            missing.push('Indicazione partecipazioni tra società (collegate/associate)');
        }
        if (this.request.PartnersParticipation === null || this.request.PartnersParticipation === undefined) {
            missing.push('Indicazione partecipazioni dei soci in altre società');
        }
        if (!this.request.InvestmentMode) {
            missing.push('Modalità di investimento (Leasing / Finanziamento / Fondi propri)');
        }

        if (this.request.InvestmentMode && this.request.InvestmentMode !== 'Fondi Propri') {
            if (!this.request.LeasingCompanyName || this.request.LeasingCompanyName.trim().length < 2) {
                missing.push('Nome società di leasing / finanziatrice');
            }
            if (!this.request.InvestmentDuration) {
                missing.push('Durata leasing / finanziamento');
            }
        }

        if (this.request.FKIDRequestType === 6 || this.request.FKIDRequestType === 7) {
            if (!this.request.TaxCredit5CadastralCode || this.request.TaxCredit5CadastralCode.trim().length === 0) {
                missing.push('Codice catastale struttura produttiva');
            }
            if (!this.request.TaxCredit5CadastralSection || this.request.TaxCredit5CadastralSection.trim().length === 0) {
                missing.push('Sezione catastale struttura produttiva');
            }
            if (!this.request.TaxCredit5CadastralSheet || this.request.TaxCredit5CadastralSheet.trim().length === 0) {
                missing.push('Foglio catastale struttura produttiva');
            }
            if (!this.request.TaxCredit5CadastralParticle || this.request.TaxCredit5CadastralParticle.trim().length === 0) {
                missing.push('Particella catastale struttura produttiva');
            }
            if (!this.request.TaxCredit5CadastralSub || this.request.TaxCredit5CadastralSub.trim().length === 0) {
                missing.push('Sub catastale struttura produttiva');
            }
            if (isDepreciationDataInvalid(this.request, this.multipleDepreciationRates)) {
                missing.push('Aliquota di ammortamento');
            }
        }

        if (!this.request.OperationalHeadquarters || this.request.OperationalHeadquarters.trim().length < 2) {
            missing.push('Comune sede operativa');
        }
        if (!this.request.OperationalHeadquartersProvince ||
            this.request.OperationalHeadquartersProvince.trim().length !== 2) {
            missing.push('Provincia sede operativa');
        }
        if (!this.request.OperationalHeadquartersAddress ||
            this.request.OperationalHeadquartersAddress.trim().length < 2) {
            missing.push('Via sede operativa');
        }
        if (!this.request.OperationalHeadquartersHouseNumber ||
            this.request.OperationalHeadquartersHouseNumber.toString().trim().length === 0) {
            missing.push('Civico sede operativa');
        }

        if (this.request.Concessions) {
            if (!this.request.ConcessionsDetails || this.request.ConcessionsDetails.trim().length < 2) {
                missing.push('Dettaglio altre agevolazioni sull’investimento');
            }
        }

        const investmentAmount = parseItalianAmountToNumber(this.investmentAmountDisplay)
            ?? this.request.InvestmentAmount;
        if (investmentAmount === null || investmentAmount === undefined) {
            missing.push('Importo totale dell’investimento');
        }

        if (!this.request.AtecoCode || this.request.AtecoCode.trim().length < 2) {
            missing.push('Codice ATECO dell’attività');
        }

        if (this.request.FKIDRequestType !== 6) {
            if (!this.checkboxInvestmentTypeValues.some((v: boolean) => v)) {
                missing.push('Categoria dell’investimento (Ordinario / Green / 4.0)');
            }
        }

        if (this.request.FKIDRequestType === 2 || this.request.FKIDRequestType === 4) {
            if (this.request.TaxCredit4Years === null || this.request.TaxCredit4Years === undefined) {
                missing.push('Scelta modalità compensazione credito d’imposta');
            }
            if (this.request.TaxCredit4Years === false) {
                if (this.request.TaxCredit4YearsCompensation === null || this.request.TaxCredit4YearsCompensation === undefined) {
                    missing.push('Anni in cui compensare il credito d’imposta');
                }
            }
            if (!this.request.TaxCredit4StartDate) {
                missing.push('Data presunta di avvio dell’investimento');
            }
            if (!this.request.TaxCredit4EndDate) {
                missing.push('Data presunta di conclusione dell’investimento (data stimata di consegna del bene)');
            }
        }

        if (this.request.FKIDRequestType === 6 || this.request.FKIDRequestType === 7) {
            if (this.request.TaxCredit5Regulations === null || this.request.TaxCredit5Regulations === undefined) {
                missing.push('Rispetto normative sicurezza e contributive');
            }
            if (this.request.TaxCredit5Revisor === null || this.request.TaxCredit5Revisor === undefined) {
                missing.push('Indicazione revisore legale dei conti');
            }
            if (this.request.TaxCredit5Revisor) {
                if (!this.request.TaxCredit5RevisorEmail || this.request.TaxCredit5RevisorEmail.trim().length < 2) {
                    missing.push('Contatto e-mail revisore legale dei conti');
                }
                if (!this.request.TaxCredit5RevisorPhone || this.request.TaxCredit5RevisorPhone.trim().length < 2) {
                    missing.push('Contatto telefonico revisore legale dei conti');
                }
            }
            if (!this.request.TaxCredit5EndDate) {
                missing.push('Data presunta di conclusione investimento');
            }
        }

        if (this.request.FKIDRequestType !== 5) {
            if (this.request.BusinessExpansion === null || this.request.BusinessExpansion === undefined) {
                missing.push('Scopo dell’investimento (ampliamento aziendale)');
            }
        } else {
            if (!this.request.TaxCredit5BusinessExpansion) {
                missing.push('Scopo dell’investimento (ampliamento / sostituzione)');
            }
        }

        return missing;
    }

    getMissingFieldsStep5(): string[] {
        const missing: string[] = [];

        if (!this.checkboxRelease[0]) {
            missing.push('Accettazione informativa sugli investimenti agevolati');
        }
        if (!this.checkboxRelease[1]) {
            missing.push('Accettazione liberatoria di responsabilità');
        }
        return missing;
    }

    getMissingFieldsStep8(): string[] {
        const missing: string[] = [];
        const hasDocs = (id: number) => this.documentList[id] && this.documentList[id].length > 0;
        const requireFullDocs = !this.request.Simplified;

        if (this.request.FKIDRequestType !== 5 && this.request.FKIDRequestType !== 6 && this.request.FKIDRequestType !== 7 && !this.request.Simplified) {
            if (!hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (!hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (!hasDocs(3)) { missing.push('Marca da bollo da 16€'); }
            if (!hasDocs(4)) { missing.push('Carta di identità del titolare / legale rappresentante'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType !== 5 && this.request.FKIDRequestType !== 6 && this.request.FKIDRequestType !== 7 && this.request.Simplified) {
            if (!hasDocs(3)) { missing.push('Marca da bollo da 16€'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType === 6 && this.request.Simplified) {
            if (!hasDocs(3)) { missing.push('Marca da bollo da 16€'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType === 7 && this.request.Simplified) {
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType === 6) {
            if (!hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (!hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (!hasDocs(3)) { missing.push('Marca da bollo da 16€'); }
            if (!hasDocs(4)) { missing.push('Carta di identità del titolare / legale rappresentante'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(29)) { missing.push('DVR'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType === 7) {
            if (!hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (!hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (!hasDocs(4)) { missing.push('Carta di identità del titolare / legale rappresentante'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(29)) { missing.push('DVR'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto, Liberatoria, Procura e Privacy firmati'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion === 'Sostituzione'
            && this.request.TaxCredit5StructureOwner === 'Affittuaria') {
            if (requireFullDocs && !hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (requireFullDocs && !hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (requireFullDocs && !hasDocs(4)) { missing.push('Carte di identità dei titolari effettivi'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto di consulenza firmato'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(10)) { missing.push('Fatture, DDT e verbali di consegna del bene sostituito'); }
            if (!hasDocs(15)) { missing.push('Estratto libro cespiti'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
            if (!hasDocs(17)) { missing.push('Contratto di affitto struttura produttiva'); }
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion === 'Sostituzione'
            && this.request.TaxCredit5StructureOwner !== 'Affittuaria') {
            if (requireFullDocs && !hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (requireFullDocs && !hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (requireFullDocs && !hasDocs(4)) { missing.push('Carte di identità dei titolari effettivi'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto di consulenza firmato'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(10)) { missing.push('Fatture, DDT e verbali di consegna del bene sostituito'); }
            if (!hasDocs(15)) { missing.push('Estratto libro cespiti'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion !== 'Sostituzione'
                && this.request.TaxCredit5StructureOwner === 'Affittuaria') {
            if (requireFullDocs && !hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (requireFullDocs && !hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (requireFullDocs && !hasDocs(4)) { missing.push('Carte di identità dei titolari effettivi'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto di consulenza firmato'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
            if (!hasDocs(17)) { missing.push('Contratto di affitto struttura produttiva'); }
        } else if (this.request.FKIDRequestType === 5 && this.request.TaxCredit5BusinessExpansion !== 'Sostituzione'
            && this.request.TaxCredit5StructureOwner !== 'Affittuaria') {
            if (requireFullDocs && !hasDocs(1)) { missing.push('Visura camerale aggiornata'); }
            if (requireFullDocs && !hasDocs(2)) { missing.push('Ultimo bilancio approvato'); }
            if (requireFullDocs && !hasDocs(4)) { missing.push('Carte di identità dei titolari effettivi'); }
            if (!hasDocs(5)) { missing.push('Offerta del fornitore non timbrata'); }
            if (!hasDocs(6)) { missing.push('Contratto di consulenza firmato'); }
            if (!hasDocs(7)) { missing.push('Distinta di pagamento'); }
            if (!hasDocs(8)) { missing.push('DURC in corso di validità'); }
            if (!hasDocs(16)) { missing.push('Visura catastale struttura produttiva'); }
        }

        return missing;
    }

    onMultipleDepreciationRatesChange(checked: boolean): void {
        this.multipleDepreciationRates = checked;
        if (checked) {
            this.request.DepreciationRate = null;
            if (!this.request.DepreciationAssets?.length) {
                this.request.DepreciationAssets = createDefaultDepreciationAssets();
            }
        } else {
            this.request.DepreciationAssets = null;
        }
    }

    addDepreciationAsset(): void {
        if (!this.request.DepreciationAssets) {
            this.request.DepreciationAssets = [createEmptyDepreciationAsset()];
            return;
        }
        this.request.DepreciationAssets.push(createEmptyDepreciationAsset());
    }

    removeDepreciationAsset(index: number): void {
        if (!this.request.DepreciationAssets || this.request.DepreciationAssets.length <= 2) {
            return;
        }
        this.request.DepreciationAssets.splice(index, 1);
    }

    private syncDepreciationBeforeSave(): void {
        syncDepreciationFieldsForSave(this.request, this.multipleDepreciationRates);
    }
}
